<template>
  <div class="one">
    <span style="font-size:38px">公众科学介绍</span>
    <h3>公众科学</h3>
    <p>科学数据的不断增加，使得科学家们在浩瀚的数据海洋中寻找自己感兴趣的研究对象变得越来越困难。为了解决科学家们在大数据时代所面临的问题，经过多年的实践，人们选择了<b>机器学习(Machine Learning)</b>和<b>公众科学(Citizen Science)</b>两个方法。<br>
      <b>机器学习</b>的方法就是通过应用最新的机器学习的算法帮助科学家实现数据处理的自动化和高速化。<br>
      <b>公众科学</b>是指通过合理地设计用户界面，让大众参与到海量科学数据的处理中来。
      目前已有的机器学的方法（尤其是监督学习）还无法做到联想和自动扩展，而人脑在灵活性上要远超目前机器学习的算法，所以公众科学不但能在某种程度上独立地解决大数据问题，而且还可以与机器学习的方法结合起来，让科研工作变得更加高效灵活。
    </p>

    <h3>什么是公众科学</h3>
    <p>简单来说，公众科学是专业科研人员和业余爱好者之间的一种合作。此类合作包括且不限于：协同观测、数据分析、分布式计算、民众科学家主导的问询等等。<br>
      随着科技的发展，人类的未知边界在不断的扩展，科学研究的方式也逐渐地发生了变化。一方面，科学家们需要民众科学家帮助他们收集数据、查缺补漏、发现盲点等等。另一方面，公众科学反过来还可以提高大众的科学素质。</p>

    <h3>公众科学在天体物理中的应用</h3>
    <p>天体物理应该是公众科学发展最繁荣的领域之一。</p>
    <p><b>协同观测</b>中比较新颖的一个项目叫做“淡水鳌虾（CrayFish，Cosmic RAYs Found In Smartphones）”。这个项目的科学目的是探测高能宇宙射线。其基本想法是以全球所有智能手机摄像头的感光元件为观测单元，志愿者可以通过安装他们开发的智能手机应用CrayFis，把自己手机的感光元件连接到一个观测网络上，然后在志愿者的手机闲置的时候，CrayFis会开启手机的观测宇宙射线的模式，并将观测到的数据传回到CrayFis团队的服务器上。该团组的天体物理学家们会对这些数据进行更复杂的筛选和建模来研究高能宇宙线的性质。</p>
    <p><b>图样识别</b>是公众科学在天体物理学中最广泛的应用，其中最著名的项目之一被称作 <a href="https://www.galaxyzoo.com/">“星系动物园（Galaxy Zoo）”</a>。志愿者对星系图片的形状进行分类并标注，科学家们将根据这些标注研究星系形状的统计性质，从而给出更合理的星系形成和演化模型；中国虚拟天文台团组推出了 <a href="https://nadc.china-vo.org/psp/">公众超新星搜寻项目</a> ，中国的大众天文学家们已经通过该平台发现了70余颗超新星和新星候选体，其中的30多颗已经得到了光谱确认。</p>

    <div>
      <img src="../assets/zoo.jpg"
           alt="">
    </div>
    <h4 style="margin-top:5vh;border-bottom:1px solid black;width:40%;margin-left:4%">星系动物园项目主页（图源： <a href="https://galaxyzoo.org">galaxyzoo.org</a>） </h4>
    <p style="margin-top:3vh"><b>民众科学家问询</b>是又一个有代表性的应用，这种方式存在的原因是：科学工作者的精力有限，他们不可能详细观察并思考每一个已观测到的天体，但大众可以帮助科学家仔细观察大量样本并给予反馈。另一方面，科学工作者们在选择研究对象时，会强烈地依赖自己的科研兴趣，这样很多有用的数据也许在初期筛选时就被忽略掉了。统计上讲，民众科学家在选择样本时不带有明显的兴趣偏向性，所以他们会帮忙挖掘那些被科学家忽略掉的但很有意思的系统。</p>

    <!-- 回到顶部 -->
    <el-backtop :visibility-height="50"
                :bottom="120">
    </el-backtop>
  </div>

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.one {
  line-height: 40px;
  color: rgb(44, 62, 80);
  a {
    color: rgb(10, 108, 255);
  }
  h4 {
    margin-top: 5px;
    font-size: 16px;
  }
  h3 {
    font-size: 24px;
  }
  p {
    margin-top: 5px;
    text-indent: 2em;
    // line-height: 30px;
    text-align: justify; /*实现两端对齐*/
    font-size: 16px;
  }
  img {
    width: calc(100% - 50px);
    height: auto;
    position: relative;
    left: 3.5%;
  }
}
</style>